<template>
  <div class="table-container" id="time-line">
    <div>
  <div class="table-container"   style="min-width: 1100px">
    <p style="font-size: 26px;margin-top:20px;margin-left: 25px">盲人用户</p>
    <Tabs value="name1" style="margin-top:20px;margin-left: 25px">
      <TabPane label="盲人" name="name1">
        <Row>
          <Col span="14">
          <Row style="margin: 3% 5%">
            <Col span="18"><Input type="text" placeholder="用户昵称" v-model="nickNameSearch" @keydown.enter.native="searchName">
            </Input></Col>
            <Col span="4"> <Button type="primary" icon="ios-search" @click.native="searchName"></Button></Col>
          </Row>
          </Col>
          <Col span="5">
          <Button type="warning"  style="margin-top: 8%;margin-left: 70%" @click.native="putBlack">加入黑名单</Button>
          </Col>
        </Row>
        <Card class="mainBox"> <!--主要内容-->
          <Tabs value="main1" type="card">
            <TabPane :label="totalUser" name="main1"><!--全部用户-->
              <Table stripe :columns="columnsMain"
                     :data="bindUsers"
                     :loading="tableLoading"
                     ref="select"
                     @on-selection-change="handleSelectRow()">
              </Table>
              <Page :total="dataCount"
                    :page-size="pageSize"
                    show-total
                    class="paging"
                    @on-change="changePage">
              </Page>
            </TabPane>
            <!--<TabPane :label="starUser" name="main2"></TabPane>-->
          </Tabs>
        </Card>
      </TabPane>
      <TabPane label="黑名单" name="name2">
        <Row>
          <Col span="14">
          <Row style="margin: 3% 5%">
            <Col span="18"><Input type="text" placeholder="用户昵称" v-model="nickNameSearch" @keydown.enter.native="searchBlackName">
            </Input></Col>
            <Col span="4"> <Button type="primary" icon="ios-search" @click.native="searchBlackName"></Button></Col>
          </Row>
          </Col>
          <Col span="5">
          <Button type="warning"  style="margin-top: 8%;margin-left: 70%" @click.native="dragBlack">解除黑名单</Button>
          </Col>
        </Row>
        <Card class="mainBox"> <!--主要内容-->
          <Tabs value="main1" type="card" >
            <TabPane :label="totalUser" name="main1"><!--全部用户-->
              <Table stripe :columns="columnsMain"
                     :data="blackList"
                     :loading="tableLoading"
                     ref="selection"
                     @on-selection-change="handleSelectBlackRow()"
                     >
                <!--ref="selection"-->
                <!--@on-selection-change="handleSelectRow()"-->
              </Table>
              <Page :total="dataCountBlack"
                    :page-size="pageSizeBlack"
                    show-total
                    class="paging"
                    @on-change="changePageBlack">
              </Page>
            </TabPane>
            <!--<TabPane :label="starUser" name="main2"></TabPane>-->
          </Tabs>
        </Card>
      </TabPane>
    </Tabs>
    </div>
  </div>
  </div>
</template>

<script>
  import Utils from '../../utils/util.js';
  import { formatSex, formatStatus } from "../../utils/format.js";
  export default {
    name: "blindUsers",
    data() {
      return {
        nickNameSearch:"", //搜索框中的内容
        bindUsers:[], //盲人用户信息数组
        totalUser:"全部用户",
        // starUser:"星标用户",
        askNum:"提问数量",
        checkedBlindUser:[], //已经选中的盲人用户数组
        checkedDragUser:[], //选中的要拖出黑名单的用户数组
        blackList:[], //黑名单用户
        showEdit:false, //是否是可编辑状态
        columnsMain: [
          {
            type: 'selection',
            width: 40,
            align: 'center',
            title: '全部'
          },
          {
            title: "头像",
            align: "center",
            render: (h, params) => {
              return h('img', {
                attrs: {
                  src: !params.row.avatarUrl ? "/static/avatar.jpg" : params.row.avatarUrl,
                  onerror:'javascript:this.src="/static/avatar.jpg"'
                },
                style: {
                  width: "48px",
                  height: "48px",
                  margin: "5px",
                  marginBottom: "0",
                  borderRadius: "3px"
                }
              });
            }
          },
          {
            title:"昵称",
            align:"center",
            key:"nickname"
          },
          {
            title:"状态",
            key:"status",
            align:"center",
            render: (h, params) => {
              return h('div',
                formatStatus(params.row.status)
              );
            }
          },
          {
            title:"性别",
            key:"gender",
            align:"center",
            render: (h, params) => {
              return h('div',
                formatSex(params.row.gender)
              );
            }
          },
          {
            title:"省份",
            key:"province",
            align:"center"
          },
          {
            title:"城市",
            key:"city",
            align:"center"
          },
          {
            title:"备注",
            key:"remarks",
            align:"center",
            width:100,
            render:(h, params) => {
              if(params.row.$isEdit){
                return h('input', {
                  domProps:{
                    value:params.row.remarks
                  },
                  style: {
                    border: "none",
                    width: "80px",
                    lineHeight:"20px",
                    textAlign: "center"
                  },
                  on: {
                    input: function (event) {
                      params.row.remarks=event.target.value;
                    }
                  }
                });
              }else {
                return h('div', params.row.remarks);
              }
            }
          },
          {
            title:"编辑 / 保存",
            align:"center",
            width:150,
            render: (h, params) => {
              return h('Button', {
                props:{
                  icon:"paintbrush",
                  type: "primary"
                },
                style: {
                  padding: "3px 8px",
                  borderRadius: "20px",
                  fontSize: "16px"
                },
                on:{
                  click:(event) => {
                    if(params.row.$isEdit){
                      this.handleSave(params.row);
                    }else {
                      this.handleEdit(params.row);
                    }
                  }
                }
              }, params.row.$isEdit ? "保存" : "编辑");
            }
          },
          {
            title: "详情",
            align:"center",
            render: (h, params) => {
              return h('Button', {
                props: {
                  type: "info"
                },
                on: {
                  click: () => {
                    this.functionA();//转到详情页面
                    this.$router.push({
                      path:'/blindDetail',
                      query:{
                        id:this.bindUsers[params.index].id,
                        openId:this.bindUsers[params.index].openId
                      }
                    });
                  }
                }
              }, "详情");
            }
          }
        ],
        dataCount:0, //初始化信息总条数
        pageSize:20, //每页条数
        dataCountBlack:0, //黑名单初始化信息总条数
        pageSizeBlack:20, //黑名单每页条数
        tableLoading:false, //表格是否加载
        dataSearch:{//请求的数据
          "code": 0,
          "content": {},
          "currPage": 1,
          "pageSize": 20,
          "pageTotal": 0
        },
        dataSearchBlack:{//黑名单请求的数据
          "code": 0,
          "content": {},
          "currPage": 1,
          "pageSize": 20,
          "pageTotal": 0
        }
      };
    },
    methods: {
      functionA(){ //调用menu-list的函数用于切换页面
        Utils.$emit('demo', 'blindDetail');
      },
      handleEdit(row){ //编辑->修改
        this.$set(row, '$isEdit', true);
      },
      handleSave(row){ //保存修改
        this.$set(row, '$isEdit', false);
        this.$http.post('/zm/backManage/updateAskerDescr?id='+row.id+'&remarks='+row.remarks).then(res => {
          this.$Message.success("保存成功！");
        }, err => {
          this.$Message.error("保存失败"+err.message);
        });
      },
      searchName() { //点击搜索框进行对昵称的搜索
        // console.log(this.nickNameSearch);
        this.dataSearch.content={
          "nickname":this.nickNameSearch
        };
        this.$http.post('/zm/backManage/queryAskerInfoByPage', this.dataSearch).then(res => {
          this.bindUsers = res.data.content;
          this.dataCount=res.data.pageTotal;
          this.pageSize=res.data.pageSize;
          // console.log(res.data);
        },
          err => {
            this.$Message.error("请求失败：" + err.message);
            this.tableLoading = false;
          });
      },
      searchBlackName(){
        this.dataSearchBlack.content={
          "nickname":this.nickNameSearch,
          "status":0
        };
        //获取黑名单
        this.getBlackList();
      }, //黑名单内点击搜索框对昵称进行搜索
      handleSelectRow() { //获取已经选中的盲人信息
        this.checkedBlindUser=this.$refs.select.getSelection();
      },
      handleSelectBlackRow(){ //获取已经选中的黑名单中的盲人信息
        this.checkedDragUser=this.$refs.selection.getSelection();
      },
      changePage(index){ //改变页数
        this.dataSearch.currPage=index;
        this.tableLoading=true;
        this.$http.post('/zm/backManage/queryAskerInfoByPage', this.dataSearch).then(res => {
          this.bindUsers = res.data.content;
          this.dataCount=res.data.pageTotal;
          this.pageSize=res.data.pageSize;
          this.tableLoading=false;
        },
          err => {
            this.$Message.error("请求失败：" + err.message);
            this.tableLoading = false;
          });
      },
      changePageBlack(index){ //改变黑名单页数
        this.dataSearchBlack.currPage=index;
        this.dataSearchBlack.content={
          "nickname":this.nickNameSearch,
          "status":0
        };
        this.tableLoading=true;
        this.getBlackList();
      },
      putBlack() {
        let item;
        let flag=true;
        let msg;
        for(item in this.checkedBlindUser){
          this.$http.post('/zm/backManage/addBlacklist?id='+this.checkedBlindUser[item].id).then(res => {
            },
            err => {
              flag=false;
              msg=err.data.content;
            });
        }
        if(flag){
          this.$Message.success("加入黑名单成功!");
        }else{
          this.$Message.error(msg);
        }
        //获取黑名单
        this.dataSearchBlack.content={
          "status":0
        };
        this.getBlackList();
      }, //加入黑名单
      dragBlack(){ //拖出黑名单
        let item;
        let flag=true;
        let msg;
        for(item in this.checkedDragUser){
          this.$http.post('/zm/backManage/deleteBlacklist?id='+this.checkedDragUser[item].id).then(res => {
            },
            err => {
              flag=false;
              msg=err.data.content;
            });
        }
        if(flag){
          this.$Message.success("解除黑名单成功!");
        }else{
          this.$Message.error(msg);
        }
        //获取黑名单
        this.dataSearchBlack.content={
          "status":0
        };
        this.getBlackList();
      },
      getBlackList(){ //获取黑名单
        this.$http.post('/zm/backManage/queryAskerInfoByPage', this.dataSearchBlack).then(res => {
            this.blackList = res.data.content;
            this.dataCountBlack=res.data.pageTotal;
            this.pageSizeBlack=res.data.pageSize;
            this.tableLoading=false;
          },
          err => {
            this.$Message.error("请求失败：" + err.message);
            this.tableLoading = false;
          });
      },
      getData(){ //加载页面时获取数据
        this.$http.post('/zm/backManage/queryAskerInfoByPage', this.dataSearch).then(res => {
          this.bindUsers = res.data.content;
          this.dataCount=res.data.pageTotal;
          this.pageSize=res.data.pageSize;
          // console.log(res.data);
        },
          err => {
            this.$Message.error("请求失败：" + err.message);
            this.tableLoading = false;
          });
        //获取黑名单
        this.dataSearchBlack.content={
          "status":0
        };
        this.getBlackList();
      }
    },
    activated(){
      this.getData();
    },
    destroyed() {
      console.log("销毁了");
    },
    watch:{
    }
  };
</script>

<style>
  .mainBox{/*主体内容*/
    width: 90%;
    border: solid 1px #cccccc;
    border-radius: 10px;
    margin: 2% 3%;
  }
  .paging{/*设置翻页*/
    display: block;
    margin-top:2%;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// blindUsers.vue?0be1b07a